import { render, staticRenderFns } from "./instant-points-preview.vue?vue&type=template&id=1f25aadf&scoped=true&"
import script from "./instant-points-preview.vue?vue&type=script&lang=js&"
export * from "./instant-points-preview.vue?vue&type=script&lang=js&"
import style0 from "./instant-points-preview.vue?vue&type=style&index=0&id=1f25aadf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25aadf",
  null
  
)

export default component.exports